import { Promotion } from '@/@type/promotion';
import { FormikProps } from 'formik';
import { DeepKeyOf } from '../../formik/type';
import { canMoveProps } from '../stepper/stepper';
import { StepLabel } from '../stepper/steps';
import { OfferBaseInfo } from './offer/baseInfo';
import { OfferConditions } from './offer/conditions';
import { OfferDetails } from './offer/details';
import { VoucherBaseInfo } from './voucher/baseInfo';
import { VoucherConditions } from './voucher/conditions';
import { VoucherDetails } from './voucher/details';
import { VoucherReward } from './voucher/reward';
import { Summary } from './voucher/summary';
import { OfferVoucherDetails } from './offer/voucherDetails';
import { OfferVoucherBaseInfo } from './offer/voucherBaseInfo';
import { OfferVoucherConditions } from './offer/voucherConditions';
import { LuckyDrawDetails } from './luckyDraw/luckyDrawDetails';
import { LuckyDrawReward } from './luckyDraw/luckyDrawReward';
import { DisplayInfo } from './displayInfo';

export interface IStepRendererProps {
    currentStep: StepLabel;
    commonComponentProps: {
        formik: FormikProps<Promotion>;
        setCanMoveFunc: React.Dispatch<React.SetStateAction<() => Promise<canMoveProps>>>;
        setFieldTouchedNameFunc: (name: DeepKeyOf<Promotion>) => Promise<void>;
    };
    formik: FormikProps<Promotion>;
}
export const StepRenderer: React.FC<IStepRendererProps> = (props) => {
    const { currentStep, commonComponentProps, formik } = props;
    const stepComponentMap: Record<StepLabel, () => JSX.Element> = {
        [StepLabel.VoucherBaseInfo]: () => <VoucherBaseInfo {...commonComponentProps} />,
        [StepLabel.VoucherDisplayInfo]: () => <DisplayInfo {...commonComponentProps} />,
        [StepLabel.VoucherDetails]: () => <VoucherDetails {...commonComponentProps} />,
        [StepLabel.VoucherConditions]: () => <VoucherConditions {...commonComponentProps} />,
        [StepLabel.VoucherSummary]: () => <Summary formik={formik} />,
        [StepLabel.OfferBaseInfo]: () => <OfferBaseInfo {...commonComponentProps} />,
        [StepLabel.OfferDisplayInfo]: () => <DisplayInfo {...commonComponentProps} />,
        [StepLabel.OfferDetails]: () => <OfferDetails {...commonComponentProps} />,
        [StepLabel.OfferConditions]: () => <OfferConditions {...commonComponentProps} />,
        [StepLabel.OfferVoucherBaseInfo]: () => <OfferVoucherBaseInfo {...commonComponentProps} />,
        [StepLabel.OfferVoucherDisplayInfo]: () => <DisplayInfo {...commonComponentProps} isOfferVoucher={true} />,
        [StepLabel.OfferVoucherDetails]: () => <OfferVoucherDetails {...commonComponentProps} />,
        [StepLabel.OfferVoucherConditions]: () => <OfferVoucherConditions {...commonComponentProps} />,
        [StepLabel.OfferSummary]: () => <Summary formik={formik} />,
        [StepLabel.LoyaltyDisplayInfo]: () => <DisplayInfo {...commonComponentProps} />,
        [StepLabel.LoyaltyDetails]: () => <VoucherDetails {...commonComponentProps} />,
        [StepLabel.LoyaltyConditions]: () => <VoucherConditions {...commonComponentProps} />,
        [StepLabel.LoyaltySummary]: () => <Summary formik={formik} />,
        [StepLabel.LoyaltyReward]: () => <VoucherReward {...commonComponentProps} />,
        [StepLabel.LuckyDrawBaseInfo]: () => <VoucherBaseInfo {...commonComponentProps} />,
        [StepLabel.LuckyDrawDisplayInfo]: () => <DisplayInfo {...commonComponentProps} />,
        [StepLabel.LuckyDrawDetails]: () => <LuckyDrawDetails {...commonComponentProps} />,
        [StepLabel.LuckyDrawReward]: () => <LuckyDrawReward {...commonComponentProps} />,
        [StepLabel.LuckyDrawConditions]: () => <VoucherConditions {...commonComponentProps} />,
        [StepLabel.LuckyDrawSummary]: () => <Summary formik={formik} />
    };

    const renderComponent = stepComponentMap[currentStep] || ((): JSX.Element => <div>Step not found</div>);

    return renderComponent();
};
